
import "./newfaq.css";
import faqIcon1 from "../../assets/faq1.png";
import faqIcon2 from "../../assets/faq2.png";
import faqIcon3 from "../../assets/faq3.png";
import React, { useState } from "react";
const faqItems = [
  {
    id: 1,
    question: "Who can participate in Polymath-Kids Classes?",
    answer:
      "Polymath-Kids offers a range of courses for students aged 5 to 16 years. However, there is no strict age restriction!",
  },
  {
    id: 2,
    question: "What are the timings for the classes?",
    answer:
      "Classes are scheduled at flexible timings based on mutual agreement between students and teachers, accommodating global time zones.",
  },
  {
    id: 3,
    question: "What will my child learn?",
    answer:
      "Your child will develop Life Skills not commonly taught in schools, like Abacus Brain Training, Coding, Graphic Design, Qur'an, Business Skills, and more!",
  },
  {
    id: 4,
    question: "Is the payment method secure? Which options are available?",
    answer:
      "Yes, payments are 100% secure! We offer Wise Transfer, Online Bank Transfers, and Jazz Cash (for Pakistan). Both one-time and subscription payments are available.",
  },
  {
    id: 5,
    question: "How does Polymath-Kids ensure online learning safety?",
    answer:
      "We strictly follow data protection guidelines. Check our Privacy Policy to learn how we safeguard your child’s online experience.",
  },
  {
    id: 6,
    question: "How can I register for Polymath-Kids courses?",
    answer:
      "Sign up on our website, complete the details, and after payment confirmation, get access to your selected course within 24 hours!",
  },
  {
    id: 7,
    question: "How long does it take to complete one module?",
    answer:
      "Module durations vary by course. Please refer to the specific course structure for detailed information.",
  },
];

const newfaq = () => {
  const [openId, setOpenId] = useState(null);

  const toggleAnswer = (id) => {
    setOpenId((prevId) => (prevId === id ? null : id));
  };

  return (
    <div className="faqs-page">
      


      <section className="faqs-content">
        <div className="container">
          <h2 className="faq-main-heading">
            <span className="purple-custom">Frequently </span>
            <span className="pink-custom">Asked Questions</span>
          </h2>

          <img src={faqIcon1} alt="FAQ Icon 1" className="faq-icon faq-icon1" />
          <img src={faqIcon2} alt="FAQ Icon 2" className="faq-icon faq-icon2" />
          <img src={faqIcon3} alt="FAQ Icon 3" className="faq-icon faq-icon3" />

          <div className="faqs-container">
            {faqItems.map(({ id, question, answer }) => (
              <div
                className={`faq-box ${openId === id ? "open" : ""}`}
                key={id}
                onClick={() => toggleAnswer(id)}
              >
                <div className="faq-question-line">
                  <h4 className="faq-question-text">Q: {question}</h4>
                  <span className="faq-toggle">
                    {openId === id ? "-" : "+"}
                  </span>
                </div>
                {openId === id && (
                  <div className="faq-answer-text">{answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      
    </div>
  );
}
export default newfaq